import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import { SourceType } from '@returnmates/client-core/src/constants/sourceType'
import { TRIP_STATUS_MAP } from '@returnmates/client-core/src/constants/trip'
import { TripStatus, TripTracking } from '@returnmates/client-core/src/graphql/generated/api'
import clsx from 'clsx'
import moment from 'moment'
import momentTz from 'moment-timezone'
import { memo, useMemo } from 'react'
import { Field, useField } from 'react-final-form'

import useStyles from '../styles'

interface Props {
  tracking?: (TripTracking | null)[]
  fieldName: string
}

function TrackingRow({ tracking, fieldName }: Props): JSX.Element {
  const classes = useStyles()
  const { input: createdBy } = useField(`${fieldName}.createdBy`)
  const { input: trackingDate } = useField(`${fieldName}.date`)

  const rescheduledDate = useMemo(() => {
    const currentFieldNameIndex = fieldName.match(/\d/g)?.join('') as string

    const prevTrackingWithDate = tracking?.find((item, index) => {
      return item?.date && index > +currentFieldNameIndex
    })

    return `Rescheduled from ${moment(prevTrackingWithDate?.date).format('MM/DD')} to ${moment(
      trackingDate.value,
    ).format('MM/DD')}`
  }, [trackingDate.value, fieldName, tracking])

  return (
    <TableRow className={classes.tableRow}>
      <TableCell className={clsx(classes.bodyCell, classes.noWrapText)}>
        <Field name={`${fieldName}.createdAt`}>
          {({ input }) => (
            <p>
              {momentTz
                .unix(input.value)
                .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
                .format('M/D/YY h:mm A z')}
            </p>
          )}
        </Field>
      </TableCell>
      <TableCell className={classes.bodyCell}>
        <Field name={`${fieldName}.status`}>
          {({ input }) => <p>{TRIP_STATUS_MAP[input.value as TripStatus] || rescheduledDate}</p>}
        </Field>
      </TableCell>
      <TableCell className={classes.bodyCell}>
        <Field name={`${fieldName}.source`}>
          {({ input }) => (
            <p>
              {`${input.value.replace('_', ' ')} ${
                input.value === SourceType.WILSON && createdBy?.value?.email
                  ? `- ${createdBy?.value?.email?.replace('_', ' ')}`
                  : ''
              }`}
            </p>
          )}
        </Field>
      </TableCell>
    </TableRow>
  )
}

export default memo(TrackingRow)
